(() => {
  const brandPattern = /\b(BROYA|Broya)\b/g;
  const skipTags = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'INPUT',
    'SELECT',
    'OPTION',
    'SVG',
    'IMG',
  ]);

  const shouldSkip = (node) => {
    const parent = node.parentElement;
    if (!parent) return true;
    if (skipTags.has(parent.tagName)) return true;
    if (parent.closest('.broya-brand-word, [aria-hidden="true"], [contenteditable="true"]')) return true;
    return !brandPattern.test(node.nodeValue);
  };

  const wrapBrandText = (root = document.body) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        brandPattern.lastIndex = 0;
        return shouldSkip(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });

    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);

    matches.forEach((node) => {
      brandPattern.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      let match;

      while ((match = brandPattern.exec(node.nodeValue)) !== null) {
        if (match.index > lastIndex) {
          fragment.append(document.createTextNode(node.nodeValue.slice(lastIndex, match.index)));
        }

        const span = document.createElement('span');
        span.className = 'broya-brand-word';
        span.textContent = match[0];
        fragment.append(span);
        lastIndex = brandPattern.lastIndex;
      }

      if (lastIndex < node.nodeValue.length) {
        fragment.append(document.createTextNode(node.nodeValue.slice(lastIndex)));
      }

      node.parentNode.replaceChild(fragment, node);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wrapBrandText(), { once: true });
  } else {
    wrapBrandText();
  }
})();
